import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/_table/Table';
import columns from './columns';
import './OrderCancelConfirmModal.scss';

const OrderCancelConfirmModal = (props) => {
  const { form, isOpen, onSubmit, closeModal, setOrderItemList, orderItemList, okText } = props;

  return (
    <Modal
      title="재고/상품상태 설정"
      isOpen={isOpen}
      width={1000}
      height={600}
      isFooter={true}
      okText={okText}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="cancel-sales-confirm-modal-wrap">
        <div className="cancel-sales-confirm-info">
          <div>판매를 취소할 경우, 해당 주문건에 포함된 상품의 재고/상태값이 변경됩니다.</div>
          <div>변경될 상품의 재고/상태값을 확인하고, 적절하게 설정해주세요.</div>
        </div>

        <Table
          rowKey={(record) => record.orderItemId}
          list={orderItemList}
          showSizeChanger={false}
          scroll={{ x: true }}
          columns={() =>
            columns({
              form,
              setOrderItemList,
              orderItemList,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default OrderCancelConfirmModal;
